module.exports = __webpack_public_path__ + "img/w3_sort_bars_asc_white.fd7f3d92.png";